/*
  WHIFF V2 | core (vaiheet 7A-7B)

  YHTEINEN LASKENTA tuotesivulle ja ostoskoripaneelille. Yksi paikka, ei kahta laskuria.
  - Toimitusarvio: lahtopaiva (ma-pe, poikkeuspaivat, viimeinen tilausaika), perillaolovali maan mukaan
  - Etupalkki: ilmainen toimitus / ilmainen 2 ml, valuuttamuunnos, tekstit summan mukaan
  - Maavalinta (Shopifyn localization-lomake taustalla, sivu ei lataudu uudelleen)
  - Ostoskoripaneeli: kun King renderoi paneelin uudelleen (maara, poisto, lisays),
    uudet toimitus- ja etulaatikot lasketaan heti. Rakenne tulee aina Liquidista.
  - Lahjaviesti: tallennetaan cart attributena (gift_message) Shopifyn omalla /cart/update -kutsulla.
  - Avattavat kohdat: WHIFFin details-elementit avautuvat selaimen omalla tavalla (ei Kingin haitaria).

  Data: snippets/whiff-offers-config.liquid (rajat, lahetyssaanto) ja
  snippets/whiff-delivery-estimate.liquid (maakohtainen toimitusaika metaobjekteista).

  Ladataan seka sections/whiff-global.liquid -osiosta etta tuotesivun buyboxista.
  Tiedosto suoritetaan vain kerran, vaikka script-tageja olisi kaksi (window.WhiffCore).
  Kingin JavaScriptiin ei kosketa.
*/
(function () {
  if (window.WhiffCore) return;
  window.WhiffCore = { version: '12' };

  /* ---------- Toimitus- ja etulaatikko (siirretty vaiheen 5B whiff-v2.js:sta sellaisenaan) ---------- */

  function offersConfig() {
    var el = document.querySelector('[data-whiff-offers]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }

  /* Rahamuoto kaupan omasta muotoilusta (Liquid money -suodattimen esimerkkiluku 1234,56) */
  function moneyFormatter(box) {
    var sample = (box.dataset.moneySample || '').trim();
    var match = /^(.*?)1(\D?)234(\D)56(.*)$/.exec(sample);
    var currency = box.dataset.currency || 'EUR';
    var locale = box.dataset.locale || 'en';
    return function (cents, wholeOnly) {
      var c = Math.max(0, Math.round(cents));
      if (match) {
        var units = wholeOnly ? Math.round(c / 100) : Math.floor(c / 100);
        var grouped = String(units).replace(/\B(?=(\d{3})+(?!\d))/g, match[2]);
        return match[1] + grouped + (wholeOnly ? '' : match[3] + pad2(c % 100)) + match[4];
      }
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: wholeOnly ? 0 : 2,
          maximumFractionDigits: wholeOnly ? 0 : 2
        }).format(c / 100);
      } catch (error) {
        return (c / 100).toFixed(wholeOnly ? 0 : 2);
      }
    };
  }

  function thresholdCents(eur) {
    var rate = 1;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      rate = parseFloat(window.Shopify.currency.rate) || 1;
    }
    return Math.round((eur || 0) * rate) * 100;
  }

  /* Paivamaarat lahetysmaan aikavyohykkeessa, vain paivan tarkkuudella (UTC-keskipaiva) */
  function todayIn(timezone) {
    try {
      var text = new Intl.DateTimeFormat('en-CA', {
        timeZone: timezone || 'Europe/Helsinki', year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date());
      if (/^\d{4}-\d{2}-\d{2}$/.test(text)) return new Date(text + 'T12:00:00Z');
    } catch (error) { /* vanha selain */ }
    var now = new Date();
    return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 12));
  }
  function isoDate(date) {
    return date.toISOString().slice(0, 10);
  }
  /* Kellonaika lahetysmaan aikavyohykkeessa minuutteina keskiyosta */
  function minutesIn(timezone) {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: timezone || 'Europe/Helsinki', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date());
      var h = 0, m = 0;
      parts.forEach(function (p) {
        if (p.type === 'hour') h = parseInt(p.value, 10) % 24;
        if (p.type === 'minute') m = parseInt(p.value, 10);
      });
      if (!isNaN(h) && !isNaN(m)) return h * 60 + m;
    } catch (error) { /* vanha selain */ }
    var now = new Date();
    return now.getHours() * 60 + now.getMinutes();
  }
  /* Viimeinen tilausaika ('15:00') minuutteina, tai null */
  function cutoffMinutes(config) {
    var match = /^(\d{1,2})(?:[:.](\d{2}))?$/.exec(String(config.cutoff_time || '').trim());
    if (!match) return null;
    return parseInt(match[1], 10) * 60 + parseInt(match[2] || '0', 10);
  }
  function formatCutoff(minutes, locale) {
    var h = Math.floor(minutes / 60), m = minutes % 60;
    if (/^fi/i.test(locale)) return m ? h + '.' + pad2(m) : String(h);
    var h12 = h % 12 || 12;
    return h12 + (m ? ':' + pad2(m) : '') + (h < 12 ? ' am' : ' pm');
  }
  /* Lahtopaiva: tanaan ennen viimeista tilausaikaa (same_day_before_cutoff), muuten seuraava lahetyspaiva */
  function shipPlan(config) {
    var today = todayIn(config.timezone);
    var cutoff = config.dispatch_rule === 'same_day_before_cutoff' ? cutoffMinutes(config) : null;
    if (cutoff !== null && isWorkday(today, config) && minutesIn(config.timezone) < cutoff) {
      return { today: today, ship: today, sameDay: true, cutoff: cutoff };
    }
    return { today: today, ship: nextWorkday(today, config), sameDay: false, cutoff: cutoff };
  }
  function planKey(plan) {
    return isoDate(plan.ship) + (plan.sameDay ? ':today' : '');
  }
  function addDays(date, days) {
    return new Date(date.getTime() + days * 86400000);
  }
  function isWorkday(date, config) {
    var day = date.getUTCDay() || 7;
    var days = config.dispatch_days || [1, 2, 3, 4, 5];
    var holidays = config.holidays || [];
    return days.indexOf(day) !== -1 && holidays.indexOf(isoDate(date)) === -1;
  }
  function nextWorkday(date, config) {
    var next = addDays(date, 1);
    var guard = 0;
    while (!isWorkday(next, config) && guard < 30) {
      next = addDays(next, 1);
      guard += 1;
    }
    return next;
  }
  function addWorkdays(date, count, config) {
    var result = date;
    for (var i = 0; i < count; i += 1) result = nextWorkday(result, config);
    return result;
  }
  function formatDay(date, locale) {
    var fi = /^fi/i.test(locale);
    try {
      return new Intl.DateTimeFormat(fi ? 'fi-FI' : 'en-GB', fi
        ? { weekday: 'short', day: 'numeric', month: 'numeric', timeZone: 'UTC' }
        : { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }
      ).format(date).replace(',', '');
    } catch (error) {
      return isoDate(date);
    }
  }

  /* Vaihe 7B: lyhyt paivamaaravali ostoskorin mobiiliin ("5–8 Oct" / "5.–8.10.") */
  function formatRangeShort(first, last, locale) {
    var fi = /^fi/i.test(locale);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var d1 = first.getUTCDate(), m1 = first.getUTCMonth();
    var d2 = last.getUTCDate(), m2 = last.getUTCMonth();
    var same = isoDate(first) === isoDate(last);
    if (fi) {
      if (same) return d1 + '.' + (m1 + 1) + '.';
      if (m1 === m2) return d1 + '.\u2013' + d2 + '.' + (m2 + 1) + '.';
      return d1 + '.' + (m1 + 1) + '.\u2013' + d2 + '.' + (m2 + 1) + '.';
    }
    if (same) return d1 + ' ' + months[m1];
    if (m1 === m2) return d1 + '\u2013' + d2 + ' ' + months[m2];
    return d1 + ' ' + months[m1] + ' \u2013 ' + d2 + ' ' + months[m2];
  }

  function renderShipRow(box, config) {
    var row = box.querySelector('[data-whiff-ship-row]');
    if (!row) return false;
    /* Vaihe 7B: tukematon toimitusmaa (hide_countries): ei arviota, pyydetaan valitsemaan maa */
    if (box.dataset.unsupported === 'true') {
      row.querySelector('[data-whiff-ship-line]').textContent = box.dataset.textUnsupported || '';
      row.querySelector('[data-whiff-arrive]').textContent = '';
      var shortEl = row.querySelector('[data-whiff-ship-short]');
      if (shortEl) shortEl.textContent = box.dataset.textUnsupported || '';
      row.classList.add('is-unsupported');
      row.hidden = false;
      return true;
    }
    var min = parseInt(box.dataset.minDays, 10);
    var max = parseInt(box.dataset.maxDays, 10);
    if (isNaN(min) && isNaN(max)) return false;
    if (isNaN(min)) min = max;
    if (isNaN(max) || max < min) max = min;

    var excluded = (config.hide_countries || []).indexOf(box.dataset.country) !== -1;
    if (excluded && box.dataset.match !== 'exact') return false;

    var plan = shipPlan(config);
    var today = plan.today;
    var ship = plan.ship;
    var first = addWorkdays(ship, min, config);
    var last = addWorkdays(ship, max, config);
    box._whiffShipKey = planKey(plan);

    var dayWord;
    if (plan.sameDay) {
      dayWord = '';
    } else if (isoDate(ship) === isoDate(addDays(today, 1))) {
      dayWord = box.dataset.textTomorrow || '';
    } else {
      var names = (box.dataset.textWeekdays || '').split('|');
      dayWord = names[(ship.getUTCDay() + 6) % 7] || formatDay(ship, box.dataset.locale);
    }
    var locale = box.dataset.locale;
    var dates = formatDay(first, locale);
    if (isoDate(first) !== isoDate(last)) dates += ' \u2013 ' + formatDay(last, locale);

    var sameDay = plan.sameDay && box.dataset.textShipsToday;
    var time = plan.cutoff !== null ? formatCutoff(plan.cutoff, locale) : '';
    row.querySelector('[data-whiff-ship-line]').innerHTML = sameDay
      ? box.dataset.textShipsToday.replace('[time]', time)
      : (box.dataset.textShips || '').replace('[day]', dayWord);
    row.querySelector('[data-whiff-arrive]').innerHTML = (box.dataset.textArrives || '').replace('[dates]', dates);
    var shortLine = row.querySelector('[data-whiff-ship-short]');
    if (shortLine) {
      var shortText = sameDay && box.dataset.textShipShortToday ? box.dataset.textShipShortToday : (box.dataset.textShipShort || '');
      shortLine.innerHTML = shortText
        .replace('[time]', time)
        .replace('[day]', dayWord)
        .replace('[dates]', formatRangeShort(first, last, locale));
    }
    row.classList.toggle('is-today', !!sameDay);
    row.hidden = false;
    return true;
  }

  function renderOffers(box, config, total) {
    var row = box.querySelector('[data-whiff-offers-row]');
    if (!row) return false;
    if ((config.hide_countries || []).indexOf(box.dataset.country) !== -1) {
      row.hidden = true;
      return false;
    }
    var money = box._whiffMoney || (box._whiffMoney = moneyFormatter(box));
    var sampleOn = !!config.sample_enabled;
    var freeCents = thresholdCents(config.free_shipping_eur);
    var sampleCents = thresholdCents(config.free_sample_eur);
    var max = sampleOn ? sampleCents : freeCents;
    if (!max) return false;
    total = Math.max(0, total || 0);

    var headline = sampleOn ? box.dataset.textHeadline : box.dataset.textHeadlineShip;
    row.querySelector('[data-whiff-offers-headline]').innerHTML = (headline || '')
      .replace('[free]', money(freeCents, true))
      .replace('[sample]', money(sampleCents, true));

    var shipPos = Math.min(100, (freeCents / max) * 100);
    var fillPos = Math.min(100, (total / max) * 100);
    var fill = row.querySelector('[data-whiff-progress-fill]');
    var markShip = row.querySelector('[data-whiff-mark-ship]');
    var markSample = row.querySelector('[data-whiff-mark-sample]');
    var labelShip = row.querySelector('[data-whiff-label-ship]');
    var labelSample = row.querySelector('[data-whiff-label-sample]');
    var bar = row.querySelector('[data-whiff-progress]');

    fill.style.width = fillPos + '%';
    bar.setAttribute('aria-valuenow', String(Math.round(fillPos)));
    markShip.style.left = shipPos + '%';
    markShip.classList.toggle('is-reached', total >= freeCents);
    markShip.hidden = !sampleOn;
    markSample.classList.toggle('is-reached', total >= max);

    labelShip.textContent = (box.dataset.textLabelShip || '').replace('[amount]', money(freeCents, true));
    labelShip.style.right = sampleOn ? (100 - shipPos) + '%' : '0';
    labelSample.textContent = (box.dataset.textLabelSample || '').replace('[amount]', money(sampleCents, true));
    labelSample.hidden = !sampleOn;

    var status = row.querySelector('[data-whiff-offers-status]');
    var cart = box.hasAttribute('data-whiff-cart-offers');
    var text = '';
    var stage = 'none';
    var remaining = 0;
    if (total > 0) {
      if (total < freeCents) {
        stage = 'ship';
        remaining = freeCents - total;
        text = ((cart ? box.dataset.textLeftShipCart : box.dataset.textLeftShip) || '').replace('[amount]', money(remaining));
      } else if (sampleOn && total < sampleCents) {
        stage = 'sample';
        remaining = sampleCents - total;
        text = ((cart ? box.dataset.textLeftSampleCart : box.dataset.textLeftSample) || '').replace('[amount]', money(remaining));
      } else {
        stage = 'done';
        text = sampleOn
          ? (cart ? box.dataset.textDoneAllCart : box.dataset.textDoneAll)
          : (cart ? box.dataset.textDoneShipCart : box.dataset.textDoneShip);
      }
    }
    if (box.dataset.statusHtml === 'true') {
      status.innerHTML = text || '';
    } else {
      status.textContent = text || '';
    }
    status.hidden = !text;
    row.hidden = false;
    /* Vaihe 7B: ostoskorin muut osat (suosittelut, 2 ml lahja) lukevat tilan tasta */
    if (cart) {
      box.dataset.stage = stage;
      box.dataset.remaining = String(remaining);
      box.dataset.remainingMoney = remaining ? money(remaining) : '';
      box.dataset.sampleReached = (sampleOn && total >= sampleCents) ? 'true' : 'false';
      try {
        document.dispatchEvent(new CustomEvent('whiff:offers', { detail: { box: box, stage: stage, remaining: remaining, total: total } }));
      } catch (error) { /* vanha selain */ }
    }
    return true;
  }

  var deliveryBoxes = [];

  /* Kun kello ylittaa viimeisen tilausajan (tai paiva vaihtuu), lahtopaiva paivitetaan ilman sivun latausta */
  function refreshShipDays() {
    var config = offersConfig();
    if (!config) return;
    var key = planKey(shipPlan(config));
    deliveryBoxes = deliveryBoxes.filter(function (box) { return document.body.contains(box); });
    deliveryBoxes.forEach(function (box) {
      if (box._whiffShipKey && box._whiffShipKey !== key) renderShipRow(box, config);
    });
  }
  window.setInterval(refreshShipDays, 30000);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refreshShipDays();
  });

  function initDelivery(scope) {
    var config = offersConfig();
    if (!config) return;
    (scope || document).querySelectorAll('[data-whiff-delivery]').forEach(function (box) {
      if (deliveryBoxes.indexOf(box) === -1) deliveryBoxes.push(box);
      var shipShown = renderShipRow(box, config);
      var offersShown = renderOffers(box, config, parseInt(box.dataset.cartTotal, 10) || 0);
      box.hidden = !(shipShown || offersShown);
      box._whiffHydrated = true;
    });
  }

  /* Ostoskorin summa muualle sivulle (tuotesivun laatikko) ilman /cart.js-hakua:
     paneelin Liquid kirjoittaa summan etupalkin laatikkoon (data-cart-total) jokaisessa
     renderoinnissa. Paneelin summa on siis aina Shopifyn oma, tuore luku. */
  function drawerTotal() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return null;
    var box = drawer.querySelector('[data-whiff-delivery][data-whiff-cart-offers]');
    if (!box) return drawer.querySelector('[data-cart-drawer-body]') ? 0 : null;
    var total = parseInt(box.dataset.cartTotal, 10);
    return isNaN(total) ? null : total;
  }
  function applyTotal(total) {
    var config = offersConfig();
    if (!config) return;
    deliveryBoxes = deliveryBoxes.filter(function (box) { return document.body.contains(box); });
    deliveryBoxes.forEach(function (box) {
      if (box.closest('cart-drawer')) return;
      if (String(box.dataset.cartTotal) === String(total)) return;
      box.dataset.cartTotal = total;
      renderOffers(box, config, total);
    });
  }
  function syncFromDrawer() {
    var total = drawerTotal();
    if (total === null) {
      refreshCartTotal();
      return;
    }
    applyTotal(total);
  }
  /* Varakeino vain, jos sivulla ei ole WHIFF-ostoskoripaneelia */
  function refreshCartTotal() {
    var config = offersConfig();
    if (!config || !deliveryBoxes.length || !window.fetch) return;
    var base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    fetch(base + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var gift = 0;
        (cart.items || []).forEach(function (item) {
          if (item.properties && item.properties._whiff_gift) gift += item.final_line_price || 0;
        });
        applyTotal(Math.max(0, cart.total_price - gift));
      })
      .catch(function () { /* summa pysyy ennallaan */ });
  }

  /* Kingin oma ostoskorin muutostapahtuma (pubsub). King julkaisee sen ennen paneelin
     renderointia, joten summa luetaan seuraavassa ruudunpaivityksessa. */
  var cartHooked = false;
  function hookCart() {
    if (cartHooked) return;
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { window.requestAnimationFrame(syncFromDrawer); });
        cartHooked = true;
      }
    } catch (error) { /* pubsub puuttuu */ }
  }
  hookCart();
  document.addEventListener('DOMContentLoaded', hookCart);
  window.addEventListener('load', hookCart);
  document.addEventListener('cart:updated', function () { window.requestAnimationFrame(syncFromDrawer); });


  /* ---------- Maan vaihto ----------
     Shopifyn oma localization-lomake (POST /localization, sama kuin natiivi lähetys), mutta taustalla.
     Shopify vastaa uudelleenohjauksella return_to-osoitteeseen, jonka tässä annetaan olla
     toimitusarvion osio (?sections=whiff-delivery-refresh) nykyisen kielen ja markkinan juuressa.
       - Sama markkina-osoite: vastaus renderöidään jo uudessa maassa, laatikot vaihdetaan.
         Sivu ei lataudu, ostoskori pysyy auki ja vierityskohta säilyy.
       - Markkinan osoite vaihtui (esim. /fi -> /fi-eu) tai valuutta vaihtuu: markkina, hinnat ja valuutta
         riippuvat osoitteesta, joten sivu ladataan oikeasti. Lomake lähetetään tavalliseen tapaan ja
         Shopify palaa samalle sivulle uudessa markkinassa. Ei teeskenneltyä vaihtoa.
     Pyyntö lähtee aina nykyiseen osoitteeseen (/localization samasta domainista), ja uudelleenohjaus
     seurataan tavallisesti (ei redirect: manual), joten evästeet ja markkinakonteksti toimivat kaikissa
     selaimissa, myös iPhonen Safarissa. */
  var REFRESH_SECTION = 'whiff-delivery-refresh';
  var REOPEN_KEY = 'whiff_reopen_cart';
  var switching = false;

  function currentPath() {
    return window.location.pathname + window.location.search;
  }
  function submitNormally(form) {
    if (!form || !document.body.contains(form)) {
      var live = document.querySelector('[data-whiff-country]');
      form = live && live.form;
      if (!form) return;
    }
    var input = form.querySelector('input[name="return_to"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      form.appendChild(input);
    }
    input.value = currentPath();
    /* Maa vaihdettiin ostoskorissa: kori avataan uudelleen, kun sivu on latautunut */
    if (form.closest && form.closest('cart-drawer')) {
      try { window.sessionStorage.setItem(REOPEN_KEY, '1'); } catch (error) { /* yksityinen selaus */ }
    }
    form.submit();
  }
  function reopenCart() {
    var flag = null;
    try {
      flag = window.sessionStorage.getItem(REOPEN_KEY);
      window.sessionStorage.removeItem(REOPEN_KEY);
    } catch (error) { return; }
    if (flag !== '1') return;
    window.setTimeout(function () {
      var icon = document.querySelector('list-set[data-source="cart-drawer"]') || document.querySelector('[data-source="cart-drawer"]');
      if (icon) icon.click();
    }, 300);
  }
  function boxKey(box) {
    return (box.dataset.parts || 'all') + '|' + (box.dataset.context || '');
  }
  function setBusy(on) {
    document.querySelectorAll('[data-whiff-delivery]').forEach(function (box) {
      if (on) box.setAttribute('aria-busy', 'true');
      else box.removeAttribute('aria-busy');
    });
  }
  /* Uusi laatikko saa vanhan lomakkeen ja valitsimen tunnisteet (label for, form id) */
  function keepIds(fresh, old) {
    var oldForm = old.querySelector('form');
    var newForm = fresh.querySelector('form');
    if (oldForm && newForm) {
      var oldSelect = oldForm.querySelector('select');
      var newSelect = newForm.querySelector('select');
      var newLabel = newForm.querySelector('label');
      newForm.id = oldForm.id;
      if (oldSelect && newSelect) newSelect.id = oldSelect.id;
      if (newLabel && oldSelect) newLabel.htmlFor = oldSelect.id;
    }
  }
  function swapBoxes(html, code) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = {};
    doc.querySelectorAll('[data-whiff-delivery]').forEach(function (box) {
      fresh[boxKey(box)] = box;
    });
    /* Shopify vaihtoi maan vain, jos uusi arvio on valitulle maalle. Muuten ei kosketa sivuun. */
    var keys = Object.keys(fresh);
    if (!keys.length) return false;
    for (var k = 0; k < keys.length; k += 1) {
      if (fresh[keys[k]].dataset.country !== code) return false;
    }
    var any = false;
    document.querySelectorAll('[data-whiff-delivery]').forEach(function (old) {
      var source = fresh[boxKey(old)];
      if (!source) return;
      var box = document.importNode(source, true);
      keepIds(box, old);
      /* Summa pysyy nykyisena: maan vaihto ei muuta ostoskoria */
      box.dataset.cartTotal = old.dataset.cartTotal;
      old.parentNode.replaceChild(box, old);
      any = true;
    });
    if (any) initDelivery(document);
    return any;
  }
  function localeRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }
  function switchCountry(select) {
    var form = select.form;
    var code = select.value;
    if (!form || !code || switching) return;
    var box = select.closest('[data-whiff-delivery]');
    var option = select.options[select.selectedIndex];
    var from = box ? box.dataset.currency : '';
    var to = option ? option.dataset.currency : '';
    if (!window.fetch || !window.FormData || !window.DOMParser || !window.URL || (from && to && from !== to)) {
      submitNormally(form);
      return;
    }
    switching = true;
    /* Kaikki valitsimet samaan maahan heti */
    document.querySelectorAll('[data-whiff-country]').forEach(function (other) {
      if (other !== select) other.value = code;
    });
    setBusy(true);
    var root = localeRoot();
    var data = new FormData(form);
    data.set('country_code', code);
    data.set('return_to', root + '?sections=' + REFRESH_SECTION);
    var action = new URL(form.getAttribute('action') || '/localization', window.location.href).pathname;
    /* 1) Maa tallennetaan Shopifyn omalla localization-lomakkeella.
       2) Toimitusarvio haetaan uudessa maassa: ensin lomakkeen vastauksesta, ja jos se ei ole
          osion JSON (esim. esikatselu tai Theme Editor), samasta sivusta ?sections=-haulla.
          Haku tehdään nykyisestä osoitteesta, joten esikatselu ja kieli säilyvät.
       Sivu ladataan uudelleen vain, jos markkina tai valuutta vaihtui tai haku ei onnistunut. */
    fetch(action, { method: 'POST', body: data, credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('localization');
        return response.text();
      })
      .then(function (text) {
        var html = null;
        try {
          var json = JSON.parse(text);
          html = json && json[REFRESH_SECTION];
        } catch (error) { /* vastaus oli sivu, ei osion JSON */ }
        if (html) return html;
        var url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.set('sections', REFRESH_SECTION);
        return fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' })
          .then(function (response) {
            if (!response.ok) throw new Error('sections');
            return response.json();
          })
          .then(function (json) {
            var fresh = json && json[REFRESH_SECTION];
            if (!fresh) throw new Error('sections');
            return fresh;
          });
      })
      .then(function (html) {
        /* Varmistus: osio renderöitiin samassa markkinan juuressa kuin tämä sivu */
        var wrap = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-whiff-delivery-refresh]');
        var renderedRoot = wrap && wrap.getAttribute('data-whiff-root');
        if (renderedRoot) {
          if (renderedRoot.charAt(renderedRoot.length - 1) !== '/') renderedRoot += '/';
          if (renderedRoot !== root) throw new Error('market-url');
        }
        if (!swapBoxes(html, code)) throw new Error('swap');
        switching = false;
        setBusy(false);
        try {
          document.dispatchEvent(new CustomEvent('whiff:country', { detail: { country: code } }));
        } catch (error) { /* vanha selain */ }
      })
      .catch(function (error) {
        switching = false;
        if (window.console) console.info('WHIFF: maan vaihto latasi sivun (' + (error && error.message) + ')');
        submitNormally(form);
      });
  }
  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-whiff-country]');
    if (select) switchCountry(select);
  });

  /* ---------- Ostoskoripaneeli ---------- */

  /* King vaihtaa paneelin sisallon AJAX-paivityksissa. Uudet (viela laskemattomat)
     toimitus- ja etulaatikot lasketaan heti Liquidin summasta, ja tuotesivun laatikko
     paivittyy samalla hetkella. Ei ajastimia eika /cart.js-hakua. */
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer._whiffObserved || !window.MutationObserver) return;
    drawer._whiffObserved = true;
    var observer = new MutationObserver(function () {
      var fresh = Array.prototype.filter.call(
        drawer.querySelectorAll('[data-whiff-delivery]'),
        function (box) { return !box._whiffHydrated; }
      );
      if (!fresh.length) return;
      initDelivery(drawer);
      syncFromDrawer();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  /* Lahjaviesti (cart attribute). Kentta on myos ostoskorilomakkeessa (form="cart"),
     joten se lahtee kassalle joka tapauksessa; tallennus pitaa sen tallessa
     paneelin uudelleenrenderoinneissa. Ei omaa tilaa: Shopifyn ostoskori on ainoa totuus. */
  var attributeTimers = {};
  function cartUpdateUrl() {
    var base = (window.routes && window.routes.cart_update_url) ? window.routes.cart_update_url : '/cart/update';
    return base + '.js';
  }
  function saveAttribute(field) {
    var key = field.dataset.whiffCartAttribute;
    if (!key || !window.fetch) return;
    window.clearTimeout(attributeTimers[key]);
    if (field._whiffSaved === field.value) return;
    field._whiffSaved = field.value;
    var attributes = {};
    attributes[key] = field.value;
    fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () { /* kentta lahtee kassalle lomakkeen mukana */ });
  }
  document.addEventListener('input', function (event) {
    var field = event.target.closest && event.target.closest('[data-whiff-cart-attribute]');
    if (!field) return;
    var key = field.dataset.whiffCartAttribute;
    window.clearTimeout(attributeTimers[key]);
    attributeTimers[key] = window.setTimeout(function () { saveAttribute(field); }, 400);
  });
  document.addEventListener('change', function (event) {
    var field = event.target.closest && event.target.closest('[data-whiff-cart-attribute]');
    if (field) saveAttribute(field);
  });

  /* ---------- Avattavat kohdat (details) ----------
     Kingin theme.js tekee sivun latautuessa jokaisesta details-elementistä animoidun haitarin,
     joka toimii vain, jos sisällöllä on data-accordion-content. WHIFFin kohdissa (lahjaviesti,
     lisätieto, tuotesivun Ainesosat ja Toimitus, UKK) sitä ei ole, jolloin Kingin koodi jää
     puolitiehen eikä kohta aukea. Näissä klikkaus ohitetaan Kingiltä, ja selain avaa kohdan itse. */
  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;
    if (details.querySelector('[data-accordion-content], [data-collapsible-content]')) return;
    details.style.height = '';
    details.style.overflow = '';
    event.stopPropagation();
  }, true);

  /* ---------- Kaynnistys ---------- */

  function safely(fn) {
    try {
      fn();
    } catch (error) {
      if (window.console) console.warn('WHIFF core:', error);
    }
  }
  function start() {
    safely(function () { initDelivery(document); });
    safely(watchDrawer);
  }
  window.addEventListener('load', function () { safely(reopenCart); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (event) {
    safely(function () { initDelivery(event.target); });
    safely(watchDrawer);
  });

  window.WhiffCore.initDelivery = function (scope) { safely(function () { initDelivery(scope); }); };
  window.WhiffCore.refreshCartTotal = syncFromDrawer;
  window.WhiffCore.switchCountry = switchCountry;
  window.WhiffCore.offersConfig = offersConfig;
})();